import(/* webpackMode: "eager", webpackExports: ["getData"] */ "/home/runner/work/zopping-themes/zopping-themes/lib/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/zopping-themes/zopping-themes/themes/common/Main/index.js");
